import { useEffect, useState } from "react";
import dataService from "../../../../helpers/dataService";
import { getLeadAutoStatsTotal } from "../../../../services/graal-api/leadAutoService";
import useStatFilters from "./StatFilters/useStatFilters";

const useStats = () => {
  const [isLoadingLead, setIsLoadingLead] = useState(false);
  const [isLoadingDoc, setIsLoadingDoc] = useState(false);
  const [isLoadingRenew, setIsLoadingRenew] = useState(false);
  const [isLoadingLeadAuto, setIsLoadingLeadAuto] = useState(false);
  const [isInit, setIsInit] = useState(false);
  const [leadDatas, setLeadDatas] = useState({
    PJ: "∞",
    MRP: "∞",
    AC: "∞",
    RCPRO: "∞",
    CYBER: "∞",
  });
  const [docDatas, setDocDatas] = useState({
    CP_MISSING: "∞",
    ATTESTATION_MISSING: "∞",
    ATTESTATION_EXPIRED: "∞",
  });
  const [renewData, setRenewData] = useState({
    RENEWABLE: "∞",
    RENEWABLE_30DAYS: "∞",
  });
  const [leadAutoDatas, setLeadAutoDatas] = useState({});
  const { statFilters } = useStatFilters();

  const getLeadStats = (newFilters) => {
    setIsLoadingLead(true);
    dataService.post(
      `statistics/counters/leads`,
      newFilters?.newFilters || statFilters,
      (datas) => {
        const total = datas.PJ + datas.AC + datas.MRP; // @Joan : total n'est pas utilisé ailleurs;

        setLeadDatas({ ...datas });
        setIsInit(true);
      },
      (err) => {},
      () => setIsLoadingLead(false),
    );
  };
  const getRenewStats = (newFilters) => {
    setIsLoadingRenew(true);
    dataService.post(
      `statistics/counters/policies/renewals`,
      newFilters?.newFilters || statFilters,
      (datas) => {
        setRenewData({
          RENEWABLE: datas.echeanceDepassee,
          RENEWABLE_30DAYS: datas.echeanceDansMoins30Jours,
        });
        setIsInit(true);
      },
      (err) => {},
      () => setIsLoadingRenew(false),
    );
  };
  const getLeadAutoStats = (newFilters) => {
    setIsLoadingLeadAuto(true);
    const filters = newFilters?.newFilters || statFilters;
    const payload = {
      beginAt: filters.beginAt || undefined,
      endAt: filters.endAt || undefined,
    };
    getLeadAutoStatsTotal(payload)
      .then((res) => {
        setLeadAutoDatas(res.data);
        setIsInit(true);
      })
      .catch(() => {})
      .finally(() => setIsLoadingLeadAuto(false));
  };

  const getDocStats = (newFilters) => {
    setIsLoadingDoc(true);
    dataService.post(
      `statistics/counters/files`,
      newFilters?.newFilters || statFilters,
      (datas) => {
        setDocDatas(datas);
        setIsInit(true);
      },
      (err) => {},
      () => setIsLoadingDoc(false),
    );
  };

  const refreshWithFilters = (newFilters) => {
    getLeadStats({ newFilters });
    getLeadAutoStats({ newFilters });
    getDocStats({ newFilters });
  };

  return {
    isLoadingLead,
    isLoadingDoc,
    isLoadingRenew,
    isLoadingLeadAuto,
    isLoading:
      isLoadingLead || isLoadingDoc || isLoadingRenew || isLoadingLeadAuto,
    leadDatas,
    docDatas,
    renewData,
    leadAutoDatas,
    actions: {
      getLeadStats,
      getLeadAutoStats,
      getDocStats,
      getRenewStats,
      refreshWithFilters,
    },
  };
};

export default useStats;
